var getBestPriceDiscount = function getBestPriceDiscount(data) {
  var _data$price, _data$price2;
  return (data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.bestPrice) && Boolean(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount)) ? data.price.bestPrice : undefined;
};
export default getBestPriceDiscount;